<template>
  <div class="ProductCategory">
    <div class="page-title">제품구분관리</div>
    <div>
      <ATable
        ref="table"
        :placeholder="placeholder"
        :search_field="search_field"
        :data="items"
        :disable_insert="!has_grant_write"
        hide-pagination
        border
        @cell-click="handleCellClick"
        hideButtonInsert
      >
        <el-table-column
          type="index"
          label="No"
          align="center"
          prop="index"
          :width="$width.index"
          :index="handleIndex"
        />
        <el-table-column label="이름" prop="name" align="center" width="200">
          <template slot-scope="scope">
            <el-input
              size="mini"
              maxlength="10"
              :readonly="scope.row.id !== editingId"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              v-model="scope.row.name"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="집계 표시"
          prop="stat_flag"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.stat_flag"
              :readonly="scope.row.id !== editingId"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              @change="handleChangeStatusFlag($event, scope.row, scope)"
            />
          </template>
        </el-table-column>
        <el-table-column label="비고" prop="desc">
          <template slot-scope="scope">
            <el-input
              size="mini"
              :readonly="scope.row.id !== editingId"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              v-model="scope.row.desc"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="categories"
          label="등록"
          width="60"
          class-name="align-center"
        >
          <template slot-scope="scope">
            <el-popover
              ref="popover"
              placement="bottom"
              width="280"
              trigger="click"
            >
              <ATable
                :data="categories_items"
                hide-top-panel
                hide-button-insert
                hide-pagination
              >
                <el-table-column prop="code" label="코드" width="80px" />
                <el-table-column
                  prop="name"
                  label="품목명"
                  show-overflow-tooltip
                />
              </ATable>
              <el-button
                slot="reference"
                size="mini"
                icon="el-icon-setting"
                @click="handleClickViewCategories(scope.row)"
              />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="명령" width="150">
          <template slot-scope="scope">
            <div v-show="scope.row.id === editingId">
              <el-button
                type="primary"
                size="mini"
                :disabled="!has_grant_write"
                :loading="load_button"
                @click="handleClickRegister(scope.row)"
                >저장</el-button
              >
              <el-button size="mini" @click="calcelEditing(scope.row)"
                >취소</el-button
              >
            </div>
            <div v-show="scope.row.id !== editingId">
              <el-button
                type="danger"
                size="mini"
                :disabled="!has_grant_write"
                :loading="load_button"
                @click="handleClickDelete(scope.row)"
                >삭제</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
      <div slot="buttons">
        <el-button
          type="primary"
          v-shortkey="['f2']"
          @shortkey.native="handleClickedCreate"
          @click="handleClickedCreate"
          >추가 (F2)</el-button
        >
        <el-button @click="handleClickStatusFlag"
          >집계표시 {{ check_state }}</el-button
        >
        <el-button :loading="load_button" @click="handleRegisterStatFlag"
          >집계표시 일괄등록</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { authority_level } from "@/common/mixins/authority_level";
import { base_data } from "@/common/mixins/base_data";

export default {
  name: "ProductCategory",
  mixins: [authority_level, base_data],
  data() {
    return {
      title: "제품분류",
      placeholder: "이름, 비고",
      search_field: ["name", "desc"],
      items: [],
      editingId: -1,
      oldItem: undefined,
      deleteData: undefined,
      base_data: ["table_product_category"],
      categories_items: [],
      check_state: "전체선택",
      all_stat_flag: true,
      load_button: false,
    };
  },
  computed: {
    ...mapGetters(["table_product_category", "table_product"]),
    has_grant_write() {
      return this.isWriteLevel("product_category");
    },
  },
  watch: {
    table_product_category() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    if (this.editingId < 0) {
      return;
    }
    this.calcelEditing(this.oldItem);
    this.editingId = 0;
  },
  methods: {
    init() {
      let temp_data = JSON.parse(JSON.stringify(this.table_product_category));
      /**
       * ERP-459 매출현황 집계 구분 선택 기능
       * 'stat_flag' 정보가 'Y' 인 항목만 [매출관리>매출현황] 메뉴의 일간계&업체계 항목에 집계 정보 표시
       */
      temp_data.forEach((data) => {
        if (data.stat_flag === "Y") {
          data.stat_flag = true;
        } else {
          data.stat_flag = false;
        }
      });
      let allCheck = temp_data.find((item) => !item.stat_flag);
      if (!allCheck) {
        this.check_state = "전체해제";
        this.all_stat_flag = false;
      }
      this.items = temp_data;
    },
    /** noti 옵션 반환 */
    getNotifyOptions(message, type = "s") {
      return this.util.get_notify_options(type, this.title, message);
    },
    calcelEditing(data) {
      let index = this.items.findIndex((i) => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    doDelete() {
      this.load_button = true;
      this.api.deleteProductCategory(this.deleteData).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_delete"));
      });
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = { id: 0, name: "", desc: null };
      this.items.push(this.oldItem);
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) {
        return;
      } else if (column.property === "categories") {
        this.editingId = -1;
        return;
      }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickRegister(data) {
      let isDuplicated = false;
      if (data.name.trim() === "") {
        this.util.notify(
          this,
          this.getNotifyOptions("코드를 입력해주세요.", "w")
        );
        return;
      }
      this.items.forEach((item) => {
        if (item.id !== data.id && item.name === data.name) {
          isDuplicated = true;
        }
        /**
         * ERP-459 매출현황 집계 구분 선택 기능
         * 'stat_flag' 정보가 'Y' 인 항목만 [매출관리>매출현황] 메뉴의 일간계&업체계 항목에 집계 정보 표시
         */
        if (item.stat_flag) {
          item.stat_flag = "Y";
        } else {
          item.stat_flag = "N";
        }
      });
      if (isDuplicated) {
        this.util.notify(
          this,
          this.getNotifyOptions("중복된 이름입니다.", "w")
        );
        return;
      }
      this.load_button = true;
      if (data.id) {
        this.api.updateProductCategory(data).then((res) => {
          this.load_button = false;
          this.handleResultForSave(res);
        });
      } else {
        this.api.createProductCategory(data).then((res) => {
          this.load_button = false;
          this.handleResultForSave(res, true);
        });
      }
    },
    handleClickDelete(data) {
      this.deleteData = data;
      this.util.confirm_delete(
        this,
        this.title + "[" + data.code + "]",
        this.doDelete
      );
    },
    handleResultForSave(res, isCreate) {
      const message = isCreate
        ? this.$t("message.success_create")
        : this.$t("message.success_update");
      this.handleResult(res, message);
    },
    handleResult(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.editingId = -1;
      this.util.notify(this, this.getNotifyOptions(successMessage));
    },
    handleRegisterStatFlag() {
      this.items.forEach((item) => {
        if (item.stat_flag) item.stat_flag = "Y";
        else item.stat_flag = "N";
      });
      this.load_button = true;
      this.api.updateProductCategoryStatFlagAll(this.items).then((res) => {
        this.load_button = false;
        this.handleResultForSave(res);
      });
    },
    handleClickStatusFlag() {
      this.items.forEach((item) => {
        item.stat_flag = this.all_stat_flag;
      });
      if (this.all_stat_flag) {
        this.check_state = "전체해제";
        this.all_stat_flag = false;
      } else {
        this.check_state = "전체선택";
        this.all_stat_flag = true;
      }
    },
    handleChangeStatusFlag(event) {
      if (event) {
        this.oldItem.stat_flag = true;
        let checked = this.items.find((item) => !item.stat_flag);
        if (!checked) {
          this.check_state = "전체해제";
          this.all_stat_flag = false;
        }
      } else {
        this.oldItem.stat_flag = false;
        this.check_state = "전체선택";
        this.all_stat_flag = true;
      }
    },
    handleClickViewCategories(data) {
      this.categories_items = [];
      this.table_product.forEach((item) => {
        let findItem = item.categories.find(
          (categories_item) => categories_item.product_category_id === data.id
        );
        if (findItem) {
          this.categories_items.push(item);
        }
      });
      this.categories_items.sort(function(a, b) {
        return a.code - b.code;
      });
    },
  },
};
</script>
